export default "__VITE_ASSET__4ded9ecf__"